import React from "react";
import { LightBulbIcon } from "@heroicons/react/24/outline";

function TodosEmpty() {
  return (
    <p className="text-center mt-3">
      <LightBulbIcon className="h-6 w-6 mx-auto" aria-hidden="true" />
      ¡Crea tu primera tarea!
    </p>
  );
}

export { TodosEmpty };
